/** 来源：crm/foodbuy/market Select；收敛为原生 option children 与属性透传并支持 ref。 */
import { forwardRef, type SelectHTMLAttributes } from 'react'
import { controlClassName } from './control-classes'

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  error?: boolean
  /** 占位项文案（value="" 时显示） */
  placeholder?: string
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className = '', children, error = false, placeholder, ...props },
  ref
) {
  return (
    <select ref={ref} className={controlClassName(className, error)} aria-invalid={error || undefined} {...props}>
      {placeholder !== undefined ? <option value="">{placeholder}</option> : null}
      {children}
    </select>
  )
})
